import * as React from 'react';
import { Colors } from '@prezi/dragon';
import { Sized, Colored } from './types';

const CloseIcon: React.FunctionComponent<Sized & Colored> = ({
    fill = Colors.neutral800,
    width = '24',
    height = '24',
}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0002 10.5858L7.75748 6.34314L6.34326 7.75735L10.5859 12L6.3433 16.2427L7.75752 17.6569L12.0002 13.4142L16.2428 17.6568L17.657 16.2426L13.4144 12L17.657 7.75739L16.2428 6.34317L12.0002 10.5858Z"
        />
    </svg>
);

export default CloseIcon;
